import { Component, OnInit, AfterViewInit, OnChanges, Input, Output, EventEmitter, ChangeDetectorRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { TylerMatTableDataSource } from '../../../../shared-components/angular-material/extended.class';
import { AssessmentDataCategory } from '../assessment-data-category';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { detailExpand } from '../../../../shared-components/angular-material/mat-animations';
import { AddAssessmentScoresComponent } from './add-assessment-scores/add-assessment-scores.component';
import { UserPermission } from '../../../../shared-components/user/user-permission.model';
import { SecurityService } from '../../../../shared-components/security/security.service';


@Component({
  selector: 'app-assessment-data-category-table',
  templateUrl: './assessment-data-category-table.component.html',
  styleUrls: ['./assessment-data-category-table.component.css'],
  animations: [detailExpand],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AssessmentDataCategoryTableComponent implements OnInit, AfterViewInit, OnChanges {

  // Properties
  private _sort: MatSort;
  @Input() data: TylerMatTableDataSource;
  @Input() tabIndex: number;
  @Output() detailOpened = new EventEmitter<AssessmentDataCategory>();
  @Input() showChildFilters = true;
  @Input() showActionMenu = true;
  @Input() triggerChanges: EventEmitter<any>;
  @Output() getAssessmentEvent = new EventEmitter();
  triggerChangeSubscription: Subscription;
  selectedRow: AssessmentDataCategory;
  headerColumns: string[] = ['More', 'fullTitle', 'action'];
  V9UserPermissions: UserPermission[] = [];
  userCanProcess: boolean;

  constructor(
    private dialog: MatDialog,
    private changeDetector: ChangeDetectorRef,
    private router: Router,
    private securityService: SecurityService,
  ) { }

  get sort(): MatSort {
    return this._sort;
  }

  @ViewChild(MatSort, { static: true }) set sort(value: MatSort) {
    this._sort = value;
    if (this.data) {
      this.data.sort = this._sort;
    }
  }

  // Event Functions
  ngOnInit() {
    if (this.showActionMenu == false) {
      this.headerColumns = ['More', 'fullTitle'];
    }
    // POST: subscribes to manual changes
    if (this.triggerChanges) {
      this.triggerChangeSubscription = this.triggerChanges.subscribe(() => {
        this.changeDetector.markForCheck();
      });
    }

    this.V9UserPermissions = this.securityService.userPermissions;
    // Maintain Scores for Individual Students
    const userCanAdd = this.V9UserPermissions.filter(permission => (permission.PermissionCode == 'AS_MSFIS'))[0];
    if (userCanAdd != undefined && userCanAdd != null) {
      this.userCanProcess = true;
    }
  }

  ngAfterViewInit() {
    // POST: sets the sort of the data
    if (this.data && this.sort) {
      this.data.sort = this.sort;
    }
  }

  ngOnChanges() {
    // POST: sets the sort of the data
    if (this.data && this.sort) {
      this.data.sort = this.sort;
    }
  }

  rowClick(row: AssessmentDataCategory) {
    // PRE: a row is clicked
    // POST: toggles that row and detects changes
    this.data.toggleExpanded(row);
    this.detailOpened.emit(row);
    this.selectedRow = row;
    setTimeout(() => {
      this.triggerChanges.emit();
    }, 0);
  }

  addScores(event, dataCategory: AssessmentDataCategory) {
    event.stopPropagation();
    let layoutVersionId = 0;
    if (dataCategory.layoutVersionId != undefined && dataCategory.layoutVersionId > 0) {
      layoutVersionId = dataCategory.layoutVersionId;
    }
    const dialogRef = this.dialog.open(AddAssessmentScoresComponent, {
      height: '100vh',
      width: '60vw',
      disableClose: true,
      data: {
        instanceId: 0,
        testMasterLayoutVersionId: layoutVersionId,
        assessmentData: [],
        editMode: false
      }
    });
    dialogRef.afterClosed().subscribe(action => {
      if (action == 'save') {
        this.getAssessmentEvent.emit(true);
      }
    });
  }

  getAssessemntData(value) {
    if (value) {
      this.getAssessmentEvent.emit(true);
    }
  }

}
